export default __webpack_public_path__ + "static/media/DSC_7375.2ccacf31.jpg";